<template>
  <div class="AdviseBanner">
    <div v-if="imgList.length === 1">
      <img
        :src="imgList[0].imgUrl"
        alt
        width="100%"
        height="100%"
        @click="navigator(imgList[0])"
      />
    </div>
    <div v-if="imgList.length > 1">
      <Carousel
        :height="height + 'px'"
      >
        <CarouselItem
          v-for="(item, index) in imgList"
          :key="index"
        >
          <img
            :src="item.imgUrl"
            alt
            width="100%"
            height="100%"
            :class="`img18-${index}`"
            @click="navigator(item)"
          />
        </CarouselItem>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { Carousel , CarouselItem } from 'element-ui';
export default {
  name: 'AdviseBanner',
  components: { Carousel , CarouselItem},
  props: {
    imgList: {
      type: Array,
      default: function(){
        return [];
      },
    },
  },
  data(){
    return {
      height: 300,
    };
  },
  methods: {
    navigator(item){
      if (item.url) window.df_sdk_common.location.href = item.url;
    },
  },
};
</script>

<style>

</style>